import { useContext, createContext, type RefObject } from 'react'
import type { ReCAPTCHARef } from '@sevenrooms/ui-kit/core'

type ReCaptchaContextType = RefObject<ReCAPTCHARef> | null
export const ReCaptchaContext = createContext<ReCaptchaContextType>(null)

export function useRecaptchaRef() {
  const context = useContext(ReCaptchaContext)
  if (context === null) {
    throw new Error('useRecaptchaRef must be used within a ReCaptchaContext.Provider')
  }
  return context
}
